export default{
  priceTables: (state) => state.priceTables,
  priceTableHelpers: (state) => state.priceTableHelpers,
  priceTable: (state) => state.priceTable
}



// WEBPACK FOOTER //
// ./src/components/pricetable/store/getters.js